/** Perguntas respondidas pelo próprio Hive (R01-14): sem modelo, com números exatos e o link da tela. */
import { unwrap, type HiveClient, type components } from '@hive/api';

export type HiveAnswer = components['schemas']['hive.core.ai.HiveAnswers.Answer'];
export type AnswersStatus = components['schemas']['hive.core.ai.AnswersController.Status'];

export function answersStatus(api: HiveClient): Promise<AnswersStatus> {
  return unwrap(api.GET('/api/v1/answers/status'));
}

export function askHive(api: HiveClient, question: string): Promise<HiveAnswer> {
  return unwrap(api.POST('/api/v1/answers', { body: { question } }));
}

/** Link interno da resposta (sempre começa com "/"); qualquer outra coisa é descartada. */
export function safeLink(link?: string | null): string | null {
  return link && link.startsWith('/') && !link.startsWith('//') ? link : null;
}

/** O Hive respondeu algo para mostrar (inclusive "seu perfil não pode ver"). */
export function hasHiveText(a?: HiveAnswer | null): boolean {
  return !!a && !!a.matched && !!a.text;
}
